import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { useFavoriteOffers } from 'hooks/favorite-offers';
import { LoyaltyOffer } from 'state/loyalty/types';

import { IncentiveCard } from '../../loyalty-incentives-components/incentive-card/incentive-card';
import { IncentiveCardDescription } from '../../loyalty-incentives-components/incentive-card/incentive-card.styled';
import { parseIncentiveData } from '../../loyalty-incentives-components/incentive-card/parse-incentive-data';

import {
  OffersInCartHeader,
  OffersInCartRemoveButton,
  OffersInCartWrapper,
} from './offers-in-cart.styled';

interface IOffersInCartProps {
  offers: Array<LoyaltyOffer>;
  handleClick: ({
    incentiveSanityId,
    incentiveName,
    loyaltyEngineId,
  }: {
    incentiveSanityId: string;
    incentiveName: string;
    loyaltyEngineId: string;
  }) => VoidFunction;
  handleRemove: (incentive: LoyaltyOffer) => void;
  favoriteEnabled?: boolean;
}

export const OffersInCart: FC<IOffersInCartProps> = ({
  offers,
  handleClick,
  handleRemove,
  favoriteEnabled,
}) => {
  const { formatMessage } = useIntl();
  const { isFavorite, isOfferLoading, toggleFavorite } = useFavoriteOffers();
  const headerText = offers.length === 1 ? 'offerAddedToCart' : 'offersAddedToCart';

  // A future ticket will change Remove handler to work at the item level.
  // For now this feature is used only with one offer in cart rule, so taking the first one is valid.
  const [firstOffer] = offers;

  return (
    <OffersInCartWrapper data-testid="offers-in-cart">
      <OffersInCartHeader>
        <p>{formatMessage({ id: headerText })}</p>
        <OffersInCartRemoveButton onClick={() => handleRemove(firstOffer)}>
          {formatMessage({ id: 'remove' })}
        </OffersInCartRemoveButton>
      </OffersInCartHeader>
      {offers.map((offer: LoyaltyOffer, idx: number) => {
        const incentiveData = parseIncentiveData(offer);
        return (
          <IncentiveCard
            key={offer.loyaltyEngineId || idx}
            incentiveData={incentiveData}
            handleClick={handleClick}
            favoriteEnabled={favoriteEnabled}
            favorited={favoriteEnabled && isFavorite(offer._id || '')}
            favoriteLoading={isOfferLoading(offer._id || '')}
            handleToggleFavorite={toggleFavorite}
          >
            {incentiveData.description && (
              <IncentiveCardDescription content={incentiveData.description} />
            )}
          </IncentiveCard>
        );
      })}
    </OffersInCartWrapper>
  );
};
